import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BulletinBoardFormModel } from './bulletin-board.form-model';
import { IBBSearchParams } from './bulletin-board.interface';

@Injectable({
  providedIn: 'root',
})
export class ProductRequestSearchUseCase {
  readonly #router = inject(Router);
  readonly formModel = new BulletinBoardFormModel();
  searchProductRequests(params?: Partial<IBBSearchParams>) {
    this.#router.navigate([], { queryParams: params });
  }
}
